<template lang="html">
	<vs-popup :active.sync="$props.popupActive" :title="'Technologie: ' + $props.prospect_url">

		<div 	v-if="technologies.length==0">
<h4 class="text-center">Aucune technologie trouvée </h4>
</div>

  <div class="data-container" v-else>
    <div v-for="(subItems, mainHeader) in technologies" :key="mainHeader" class="section">
      <!-- Main Header -->
      <h2 class="header">{{ formatHeader(mainHeader) }}</h2>
      
      <!-- Check if subItems is an object (for nested headers) or a direct value -->
      <div v-if="typeof subItems === 'object' && !Array.isArray(subItems)">
        <!-- Loop through nested keys and values if subItems is an object -->
        <div v-for="(values, subHeader) in subItems" :key="subHeader" class="subsection">
          <h3 class="subheader">{{ formatHeader(subHeader) }}</h3>
          <ul class="values">
            <li v-for="(value, index) in values" :key="index">{{ value }}</li>
          </ul>
        </div>
      </div>
      
      <!-- Display direct value if subItems is not an object (e.g., prospect_id) -->
      <div v-else>
        <p class="direct-value">{{ subItems }}</p>
      </div>
    </div>
  </div>

	</vs-popup>
</template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import VueCookies from "vue-cookies";
import store from "@/store/store";
import ProspectSearch from "@/entities/ProspectSearch";
export default {
	created() {
		this.fetchTechnology();
		//getting orders which belongs to user sign in
	},
	updated() {
		// //console.log("dsadsads");
		// this.getNotes();
	},
	components: {},
	mounted() {},
	name: "PropsectTechnologyPopup",
	mixins: [dbFieldConvertor],
	props: {
		popupActive: {
			type: Boolean,
			required: true,
		},
		prsopect_id: {
			type: Number,
			required: true,
		},
		prospect_url: {
			type: String,
			required: true,
		},
	},

	data() {
		return {
			// apiUrl: this.$store.state.backendApiUrl,
			technologies: [],
			keysTechnologies: [],
		};
	},
	computed: {
		activeUser: () => {
			return VueCookies.get("userInfo");
		},

		apiUrl: () => {
			return store.state.backendApiUrl;
		},
	},
	methods: {
		async fetchTechnology() {
			let response = await ProspectSearch.getProspectTechnologies(
				this.$props.prsopect_id
			);
			delete response["id"];
			delete response["prospect_id"];
			this.technologies = response;
		},
		formatHeader(header) {
			// Format headers for display (optional, to make headers more readable)
			return header.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
		},
		// /**Format string web_dev to Web Dev  */
		// formatString(str) {
		// 	// Split the string by underscores
		// 	let parts = str.split("_");

		// 	// Capitalize the first letter of each part
		// 	let capitalizedParts = parts.map(
		// 		(part) => part.charAt(0).toUpperCase() + part.slice(1)
		// 	);

		// 	// Join the parts back together with spaces
		// 	let formattedString = capitalizedParts.join(" ");

		// 	return formattedString;
		// },
	},
	watch: {},
};
</script>
<style scoped>
.data-container {
	font-family: Arial, sans-serif;
	line-height: 1.5;
	margin: 0 20px;
	max-width: 600px;
}

.section {
	margin-bottom: 20px;
}

.header {
	font-size: 1.5em;
	color: #333;
	margin-bottom: 10px;
}

.subheader {
	font-size: 1.2em;
	color: #555;
	margin-top: 10px;
	margin-bottom: 5px;
}

.values {
	font-size: 1.2em;
	padding-left: 30px;
	list-style-type: disc;
}

.values li {
	color: #666;
}

.direct-value {
	padding-left: 20px;
	color: #666;
}
</style>
